import React, { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import { Box, Card, CardContent, Divider, Typography } from '@material-ui/core';

const ADMIN_TEMPLATE_DETAIL_QUERY = gql`
  query AdminPlanTemplateDetail($id: ID!) {
    adminPlanTemplate(id: $id) {
      id
      name
      slug
      planType
      status
      updatedAt
      planModules {
        id
        title
        planSections {
          id
          title
          planQuestions {
            id
          }
        }
      }
    }
  }
`;

const PlanBuilderTemplateDetail = (props) => {
  const id = props?.match?.params?.id;
  const { data, loading, error } = useQuery(ADMIN_TEMPLATE_DETAIL_QUERY, { variables: { id }, skip: !id });

  const t = data?.adminPlanTemplate;

  const counts = useMemo(() => {
    const modules = t?.planModules || [];
    const sections = modules.flatMap((m) => m.planSections || []);
    const questions = sections.flatMap((s) => s.planQuestions || []);
    return {
      modules: modules.length,
      sections: sections.length,
      questions: questions.length,
    };
  }, [t]);

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>Plan Template</Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        <Link to="/admin/plan_builder/templates">Back to templates</Link>
      </Typography>

      {error && <Typography color="error">Error: {error.message}</Typography>}
      {loading && <Typography color="textSecondary">Loading...</Typography>}

      {t && (
        <Card>
          <CardContent>
            <Typography variant="h5">{t.name}</Typography>
            <Typography color="textSecondary">{t.slug}</Typography>
            <Divider style={{ margin: '12px 0' }} />
            <Typography><strong>Type:</strong> {t.planType}</Typography>
            <Typography><strong>Status:</strong> {t.status}</Typography>
            <Typography><strong>Updated:</strong> {t.updatedAt ? new Date(t.updatedAt).toLocaleString() : '—'}</Typography>
            <Divider style={{ margin: '12px 0' }} />
            <Typography><strong>Modules:</strong> {counts.modules}</Typography>
            <Typography><strong>Sections:</strong> {counts.sections}</Typography>
            <Typography><strong>Questions:</strong> {counts.questions}</Typography>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default PlanBuilderTemplateDetail;



